import styled from 'styled-components'
import { Select } from 'antd'

export const OptionSelect = styled(Select)`
  width: 100%;
`
